import Model, { attr } from '@ember-data/model';
import { isPresent } from '@ember/utils';

export default class AdminContactAddressChangeModel extends Model {
  @attr('string') entityName?: string;
  @attr('string') entityHostId?: string;
  @attr('string') userName?: string;
  @attr('string') userEmail?: string;
  @attr() oldAddress?: any[];
  @attr() newAddress?: any[];
  @attr('date') createdAt!: Date;
  @attr() oldPhones?: string[];
  @attr() newPhones?: string[];
  @attr() oldEmails?: string[];
  @attr() newEmails?: string[];

  get address1Changed() {
    return this.addressValueChanged('address1');
  }

  get address2Changed() {
    return this.addressValueChanged('address2');
  }

  get cityChanged() {
    return this.addressValueChanged('city');
  }

  get stateChanged() {
    return this.addressValueChanged('state');
  }

  get zipChanged() {
    return this.addressValueChanged('zip');
  }

  addressValueChanged(addressKey: string) {
    return (
      ((this as any)[`oldAddress.${addressKey}`] || '') !==
      ((this as any)[`newAddress.${addressKey}`] || '')
    );
  }

  get addressChanged() {
    let { newAddress } = this;
    return newAddress != null && Object.keys(newAddress).length > 0;
  }

  get phonesChanged() {
    return isPresent(this.newPhones);
  }

  get emailsChanged() {
    return isPresent(this.newEmails);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'admin/contact-address-change': AdminContactAddressChangeModel;
  }
}
